import { ActionIcon, Box, Button, Image, Modal } from "@mantine/core";
import { IconX } from "@tabler/icons-react";

export type SectorPromoModalData = {
  id: string;
  imageUrl: string;
  ctaLabel: string;
};

type SectorPromoModalProps = {
  opened: boolean;
  promo: SectorPromoModalData | null;
  onClose: () => void;
  onJoin: () => void;
};

const MODAL_NAVY = "#04305c";

/**
 * Full-image sector promo popup: close on image (top-right);
 * CTA sits below the image, centered, with a frame only around the button.
 */
export default function SectorPromoModal({ opened, promo, onClose, onJoin }: SectorPromoModalProps) {
  return (
    <Modal
      opened={opened && Boolean(promo)}
      onClose={onClose}
      centered
      size="auto"
      padding={0}
      radius="lg"
      withCloseButton={false}
      title=""
      overlayProps={{ backgroundOpacity: 0.6, blur: 2 }}
      styles={{
        body: { padding: 0 },
        content: {
          overflow: "visible",
          backgroundColor: "transparent",
          boxShadow: "none",
          maxWidth: "min(920px, 96vw)",
        },
      }}
    >
      {promo ? (
        <Box>
          <Box
            pos="relative"
            style={{
              borderRadius: 16,
              overflow: "hidden",
              backgroundColor: "#FFFFFF",
              lineHeight: 0,
            }}
          >
            <Image
              src={promo.imageUrl}
              alt=""
              fit="contain"
              mah="min(76vh, 700px)"
              maw="min(920px, 96vw)"
              style={{ display: "block", width: "100%", height: "auto" }}
            />

            <ActionIcon
              variant="filled"
              color="dark"
              radius="xl"
              size="lg"
              aria-label="Close"
              onClick={onClose}
              style={{
                position: "absolute",
                top: 12,
                right: 12,
                zIndex: 2,
                backgroundColor: "rgba(15, 23, 42, 0.72)",
              }}
            >
              <IconX size={18} />
            </ActionIcon>
          </Box>

          {/* Below image, bottom-center */}
          <Box
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: 0,
            }}
          >
            <Box
              style={{
                display: "inline-flex",
                alignItems: "center",
                padding: 8,
                borderRadius: "0 0 10px 10px",
                border: "1px solid #E2E8F0",
                borderTop: "none",
                backgroundColor: "#FFFFFF",
              }}
            >
              <Button
                size="md"
                radius="md"
                onClick={onJoin}
                styles={{
                  root: {
                    fontWeight: 600,
                    backgroundColor: MODAL_NAVY,
                    color: "#FFFFFF",
                    minWidth: 160,
                    "&:hover": { backgroundColor: "#042f5c" },
                  },
                }}
              >
                {promo.ctaLabel}
              </Button>
            </Box>
          </Box>
        </Box>
      ) : null}
    </Modal>
  );
}
